import { useTranslation } from 'react-i18next';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useDispatch } from 'react-redux';

import { ParticipantMedicalInterviewWithParticipant } from '@breathelife/types';

import { notificationSlice } from '../../../ReduxStore/Notification/NotificationSlice';
import { getMedicalInterview } from '../../../Services/ApplicationSupportService';
import { QueryId } from '../../common/common.types';

export function useFindApplicationSupportMedicalInterviewQuery(
  applicationId: string,
  options?: UseQueryOptions<ParticipantMedicalInterviewWithParticipant[] | null>,
): UseQueryResult<ParticipantMedicalInterviewWithParticipant[] | null> {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return useQuery<ParticipantMedicalInterviewWithParticipant[] | null>(
    [QueryId.participantMedicalInterview, applicationId],
    async () => {
      if (!applicationId) {
        return Promise.reject(new Error(`Application ID is missing while fetching medicalInterview`));
      }
      return await getMedicalInterview(applicationId);
    },
    {
      ...options,
      enabled: !!applicationId,
      onError: () => {
        dispatch(
          notificationSlice.actions.setError({
            message: t('notifications.getMedicalInterviewFailure', { applicationId: applicationId }),
          }),
        );
      },
    },
  );
}
